(function () {
  'use strict';

  angular
    .module('itecAdministracio.rols.main')
    .config(config);

  function config($stateProvider, $urlRouterProvider) {

    $stateProvider
      .state('rols.main', {
        url: '/',
        params: {
          tipus: 0,
          nom: '',
          submenuInfo: {
            visible: true,
            left: {
              visible: true,
              visibleMenu: true,
              collapsable: true,
              collapsed: false,
              name: 'DEFAULT_ROLS',
              nameCollapsed: 'DEFAULT_ROLS',
              icon: 'view_list',
              columns: 4,
              columnsCollapsed: 0
            },
            content: {
              visible: true,
              collapsable: true,
              collapsed: true,
              columnsCollapsed: 0,
              menu: {
                minColumns: 3,
                minOptions: 2
              },
              dynamicMenu: {
                minColumns: 3,
                minOptions: 2
              }
            },
            right: {
              visible: false,
              visibleMenu: false,
            }
          }
        },
        views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: function(permisosRolsHeaderSubmenuLinksValue) {
                return permisosRolsHeaderSubmenuLinksValue;
              }
            }
          },
          'leftSide': {
            templateUrl: 'rols/main/llista/llista.tpl.html',
            controller: 'RolsMainLlistaCtrl',
            controllerAs: 'ctrl',
            resolve: {
                  llistaentitats:function(EntitatFactory,$rootScope) {
                    if (!angular.isUndefined($rootScope.permisos) && $rootScope.permisos.ROL.read)
                    {
                      return EntitatFactory.getAll().catch(function(){});
                    }
                    else{
                      return undefined;
                    }
                  }
            }
          }
        }
      })
      .state('rols.main.submain', {
        url: '{idRol:[0-9]{0,32}}',
        abstract: true,
        views: {
          'content@rols': {
            templateUrl: 'shared/submain/submain.tpl.html'
          }
        },
        breadcrumb: {
          dynamicText: '{{breadcrumbText}}',
          stateName: 'rols.main.submain.dades',
          textParam: {paramName: 'label', paramValue: '{{rolData.data.nom}}'}
        },
        resolve: {
          rolData: function(RolFactory, $stateParams) {
            if ($stateParams.isNew){
              return {};
            }
            else if (!angular.isUndefined($stateParams.idRol)
                      && $stateParams.idRol !== null
                      && $stateParams.idRol) {
              return RolFactory.get($stateParams.idRol).catch(function(){});
            }
            else {
              return {};
            }
          },
          breadcrumbText: function($stateParams){
            if (angular.isUndefined($stateParams.idRol) || $stateParams.idRol === '') {
              return 'BREADCRUMB_FORMULARI_CREACIO';
            }
            else {
              return 'BREADCRUMB_LABEL';
            }
          }
        }
      });
  }
}());
